import Dialog from "../../../ui/widgets/dialog";
import Typography from "../../../ui/widgets/typography";
import Button from "../../../ui/widgets/button";
import { Dispatch, SetStateAction } from "react";
import { useMessageSource } from "react-message-source";

export interface CsDisabledInfoDialogProps {
  isActive: boolean;
  setIsActive: Dispatch<SetStateAction<boolean>>;
}

export const CsDisabledInfoDialog = ({
  isActive,
  setIsActive,
}: CsDisabledInfoDialogProps) => {
  const { getMessage } = useMessageSource();

  return (
    <Dialog open={isActive}>
      <Typography variant="h2" className="scd-container-base">
        {getMessage("DisabledProductDialog.title")}
      </Typography>
      <Typography variant="body1">
        {getMessage("DisabledProductDialog.credit-suisse.text")}
      </Typography>
      <div className="scd-dialog-footer">
        <Button onClick={() => setIsActive(false)} kind="primary">
          {getMessage("Onboarding.back")}
        </Button>
      </div>
    </Dialog>
  );
};
